import Vue from 'vue';
export const EventBus = new Vue();

export enum TypeEventBus {
    SNACKBAR = 'snackbar',
    ADD_DECIMAL_ROW = 'add_decimal_row',
    ADD_SEXAGESIMAL_ROW = 'add_sexagesimal_row',
    SELECT_FEATURES_IN_MAP = 'select_features_in_map',
    CALCULATING_POLYGON_AREA = 'calculating_polygon_area',

    HAND_WRITING_DISABLED_BUTTON = 'hand_writing_disabled_button',
    CANCEL_POLYGON_EDITION = 'cancel_polygon_edition',
    EDIT_COORDINATES = 'edit_polygon_coordinates',

    SHOW_MESSAGE = 'show_message',
    CONFIRM_DIALOG = 'confirm-dialog',
    HIGH_CLOUDY_CONFIRM_DIALOG = 'high-cloudy-confirm-dialog',
}
